/** Users Database [330:1406](https://www.figma.com/design/w336KCNkLvp8mdckFFaN2B/RAPID-V1-DRAFTS?node-id=330-1406) */
export const ADMIN_USERS_PATH = '/admin/users'

export const ADMIN_USERS = {
  headerLabel: 'Users Database',
  searchPlaceholder: 'Search by name, email, phone or ID...',
  exportLabel: 'Export',
  tabs: [
    { id: 'all', label: 'All' },
    { id: 'active', label: 'Active' },
    { id: 'inactive', label: 'Inactive' },
    { id: 'suspended', label: 'Suspended' },
    { id: 'banned', label: 'Banned' },
  ],
  columns: [
    { id: 'user', label: 'User' },
    { id: 'contact', label: 'Contact Info' },
    { id: 'status', label: 'Status' },
    { id: 'orders', label: 'Orders' },
    { id: 'wallet', label: 'Wallet Bal.' },
    { id: 'activity', label: 'Activity' },
  ],
  pagination: {
    showingPrefix: 'Showing',
    showingRange: '1 to 4',
    showingSuffix: 'of 12,450 entries',
    pages: [1, 2, 3, '…', 415],
    activePage: 1,
  },
  users: [
    {
      id: 'OPR-8829-X',
      name: 'Sarah Jenkins',
      avatarTone: 'bg-rose-100 text-rose-700',
      avatarGlyph: 'SJ',
      email: 's.jenkins@example.com',
      phone: '+234 801 234 5678',
      status: 'active',
      statusLabel: 'Active',
      orders: '1,204',
      wallet: '₦124,500.00',
      joined: '12 OCT 2023',
      last: 'just now',
    },
    {
      id: 'USR-9921',
      name: 'Aisha Bello',
      avatarTone: 'bg-violet-200 text-violet-800',
      avatarGlyph: 'AB',
      email: 'aisha.b@example.com',
      phone: '+234 803 123 4567',
      status: 'active',
      statusLabel: 'Active',
      orders: '142',
      wallet: '₦45,200.00',
      joined: '12 JAN 2023',
      last: '2 mins ago',
    },
    {
      id: 'USR-8843',
      name: 'Chuka Danjuma',
      avatarTone: 'bg-gray-100 text-gray-600',
      avatarGlyph: 'CD',
      email: 'chuka.d@domain.co',
      phone: '+234 812 987 6543',
      status: 'inactive',
      statusLabel: 'Inactive',
      orders: '12',
      wallet: '₦1,500.00',
      joined: '04 MAR 2023',
      last: '3 days ago',
    },
    {
      id: 'USR-7712',
      name: 'Emeka Okafor',
      avatarTone: 'bg-gray-900 text-white',
      avatarGlyph: 'EO',
      email: 'emeka@company.net',
      phone: '+234 905 555 1212',
      status: 'suspended',
      statusLabel: 'Suspended',
      orders: '89',
      wallet: '₦0.00',
      joined: '22 NOV 2022',
      last: '1 week ago',
    },
  ],
  mobile: {
    pageTitle: 'Users',
    searchPlaceholder: 'Search by name, ID, or phone...',
    filters: [
      { id: 'all', label: 'All' },
      { id: 'active', label: 'Active' },
      { id: 'inactive', label: 'Inactive' },
      { id: 'suspended', label: 'Suspended' },
      { id: 'banned', label: 'Banned' },
    ],
    users: [
      {
        id: 'USR-MOB-OA',
        name: 'Oluwaseun Adebayo',
        initials: 'OA',
        phone: '+234 801 234 5678',
        status: 'active',
        statusLabel: 'Active',
        avatarKind: 'photo',
        avatarBg: 'linear-gradient(135deg, #3A6A8D 0%, #1F3A4D 100%)',
      },
      {
        id: 'USR-MOB-ER',
        name: 'Elena Rodriguez',
        initials: 'ER',
        phone: '+1 (555) 019-2834',
        status: 'active',
        statusLabel: 'Active',
        avatarKind: 'initials',
        avatarBg: '#C0C1FF',
        avatarText: '#06006C',
      },
      {
        id: 'USR-MOB-MC',
        name: 'Marcus Chen',
        initials: 'MC',
        phone: '+1 (555) 823-1049',
        status: 'active',
        statusLabel: 'Active',
        avatarKind: 'photo',
        avatarBg: 'linear-gradient(135deg, #3F3D56 0%, #1F2937 100%)',
      },
      {
        id: 'USR-MOB-SJ',
        name: 'Sarah Jenkins',
        initials: 'SJ',
        phone: '+44 7911 123456',
        status: 'suspended',
        statusLabel: 'Suspended',
        avatarKind: 'initials',
        avatarBg: '#E7E8E9',
        avatarText: '#767588',
      },
      {
        id: 'USR-MOB-DP',
        name: 'Diana Prince',
        initials: 'DP',
        phone: '+1 (555) 443-9090',
        status: 'banned',
        statusLabel: 'Banned',
        avatarKind: 'photo',
        avatarBg: 'linear-gradient(135deg, #C7B299 0%, #7C6856 100%)',
        dimmed: true,
      },
      {
        id: 'USR-MOB-TR',
        name: 'Tariq Rahman',
        initials: 'TR',
        phone: '+971 50 123 4567',
        status: 'inactive',
        statusLabel: 'Inactive',
        avatarKind: 'initials',
        avatarBg: '#E7E8E9',
        avatarText: '#767588',
      },
    ],
  },
}
